<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #EEEEE7; height:100% ">
        <v-toolbar dense :color="'#FBFAF1'" style="min-height: 80px;">
            <v-spacer></v-spacer>
            <v-toolbar-title class="mt-6 text-center">
                <img src="../assets/logo7.svg" alt="Logo" style="height: 60px;">
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-row v-if="!cargando && !esAgencia" dense class="slide-card-up" justify="center">
            <h1 class="mt-4 mx-12">Su agencia no se encuentra registrada en nuestro sistema</h1>
        </v-row>

        <v-row v-if="esAgencia" dense class="slide-card-up" justify="center">
            <h1 class="mt-8 ma-4 mr-12">Hola {{ this.agencia.nombre }}!</h1>
        </v-row>
        <v-row v-if="esAgencia" dense class="slide-card-up" justify="center">
            <v-col class="text-center">
                <p style="font-size: 1.2rem;" class="mx-16">
                    Te damos la bienvenida a nuestro sistemas de reservas.
                </p>
            </v-col>
        </v-row>

        <v-row v-if="esAgencia && caminos.length > 0" class="mt-10">
            <v-col cols="3"></v-col>
            <v-col cols="6">
                <v-select background-color="white" v-model="selectedCamino" :items="caminos" item-text="titulo"
                    item-value="id" label="Selecciona un camino" outlined></v-select>
            </v-col>
            <v-col cols="3"></v-col>
        </v-row>

        <v-row v-if="esAgencia && agencias.length > 0" class="mt-4">
            <v-col cols="3"></v-col>
            <v-col cols="6">
                <v-select background-color="white" v-model="selectedAgencia" :items="agencias" item-text="nombre"
                    item-value="identificador" label="Selecciona la agencia de origen" outlined></v-select>
            </v-col>
            <v-col cols="3"></v-col>
        </v-row>

        <v-row v-if="esAgencia && caminos.length > 0" class="mt-4">
            <v-col cols="3"></v-col>
            <v-col cols="6">
                <v-select background-color="white" v-model="selectedLanguage" :items="languages" item-text="language"
                    item-value="language" label="Selecciona el idioma" outlined></v-select>
            </v-col>
            <v-col cols="3"></v-col>
        </v-row>

        <v-row v-if="esAgencia && caminos.length > 0" class="mt-4 mb-6" justify="center">
            <v-chip link @click="selectedCamino && selectedLanguage? _irACentroReservas() : null" large class="ma-2 px-8 mr-8 hover-color"
                :color="miColorAzul" :text-color="miColorNaranja"
                style="font-size: 1.2rem;">
                Ir al Formulario
                <v-icon size="2rem" right>mdi-arrow-right</v-icon>
            </v-chip>
        </v-row>

    </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    data() {
        return {
            selectedCamino: null,
            selectedAgencia: "",
            selectedLanguage: "ES",

            cargando: false,


            miColorNaranja: '#FF9C00',
            miColorAzul: '#191970',

        };
    },
    computed: {
        ...mapState("caminos", ["caminos", "agencias", "languages", "agencia"]),

        esAgencia() {
            return this.agencia != null && this.agencia.id != 1;
        },
    },
    mounted() {
        this.cargando = true;
        const agencia = this.$route.params.agencia;
        if (agencia) {
            this._getAgencia(agencia);
           
        }
        this._getCaminos();
      
    },
    methods: {
        ...mapActions("caminos", ["getCaminos", "getAgencias", "getAgencia"]),


        async _getCaminos() {
            let res = await this.getCaminos();
            this.cargando = false;
        },

        async _getAgencia(agencia) {
            const res = await this.getAgencia([agencia]);
            if (this.agencia && this.esAgencia) {
               this.selectedAgencia = this.agencia.identificador;
               this.cargando = false;
            }
        },

        _irACentroReservas() {
            this.$router.push({
                name: 'central_reservas',
                params: {
                    admin: 'ext',
                    camino_id: this.selectedCamino,
                    language: this.selectedLanguage,
                    agencia: this.selectedAgencia,
                }
            });
        },






    },
};
</script>

<style scoped></style>
